import { SectionHead } from "../components/SectionHead";
import { UseCaseCard } from "../components/UseCaseCard";
import { copy } from "../content/copy";
import { useCases } from "../content/useCases";

export function UseCasesSection() {
  return (
    <section className="section use-cases" id="use-cases">
      <div className="container">
        <SectionHead
          eyebrow={copy.useCases.eyebrow}
          title={
            <>
              Three roles, three <span className="serif-italic">real</span> environments.
            </>
          }
          lede={copy.useCases.lede}
        />
        <div className="usecase-grid">
          {useCases.map((u) => (
            <UseCaseCard key={u.id} useCase={u} />
          ))}
        </div>
      </div>
    </section>
  );
}
